/**
 * Created by idea on 14/04/2017.
 */
import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';

declare var $: any;

@Injectable()
export class UploadService {
  private header: Headers;
  responseData: any;
  handleError: any;

  constructor(private http: Http, private router: Router) {
    let contentHeaders = new Headers();
    this.header = contentHeaders;
    this.header.set('Authorization', 'Basic aWNoZWNrOmlZQUYmO2NCZSNHM2F+RDojaGVjaw==');
    if (localStorage.getItem('Access-Token')) {
      this.header.set('x-token', localStorage.getItem('Access-Token'));
    }
  }

  upload(file: File, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    let url = `${environment.uploadUrlNew}`;
    return this.postWithFile(url, file, postData);
  }

  upload2(file: File, postData?: any) {
    let url = `${environment.api}/uploads/images`;
    return this.postWithFile(url, file, postData);
  }

  uploadFileAttach(file: File, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    let url = `${environment.uploadUrlNew}`;
    return this.postWithFile(url, file, postData);
  }

  uploadImagesNew(body) {
    return this.http.post(`${environment.uploadUrlNew}`, body);
  }

  uploadImagesNew2(body) {
    return this.http.post(`${environment.uploadUrlNew}`, body);
  }

  public postWithFile(url: string, file: File, postData?: any) {
    let formData: FormData = new FormData();
    //formData.append('files', files[0], files[0].name);
    // For multiple files
    // for (let i = 0; i < files.length; i++) {
    // formData.append(`content`, file, file.name);
    formData.append('file', file);

    //}
    // if (postData !== '' && postData !== undefined && postData !== null) {
    //   for (var property in postData) {
    //     if (postData.hasOwnProperty(property)) {
    //       formData.append(property, postData[property]);
    //     }
    //   }
    // }
    var returnReponse = new Promise((resolve, reject) => {
      this.http.post(url, formData ).subscribe(
        res => {
          this.responseData = res;
          if (this.responseData.statusCode) {
            if (this.responseData.statusCode == 200 || this.responseData.statusCode == 201) {
              resolve(this.responseData);
            } else if (this.responseData.statusCode == 402) {
              localStorage.removeItem('Access-Token');
              this.router.navigate(['/login']);
              reject(this.responseData);
            } else if (this.responseData.statusCode == 401) {
              localStorage.removeItem('Access-Token');
              this.router.navigate(['/login']);
              reject(this.responseData);
            } else if (this.responseData.statusCode == 404) {
              reject(this.responseData);
            } else if (this.responseData.statusCode == 204) {
              resolve(this.responseData);
            } else {
              reject(this.responseData);
            }
          } else {
            resolve(this.responseData);
          }
        },
        error => {
          reject(error.json());
        }
      );
    });
    return returnReponse;
  }

}



// WEBPACK FOOTER //
// /app/src/app/common/services/Upload.service.ts